import React, { useCallback, useState } from 'react';

import { addDoc, collection } from 'firebase/firestore';
import toast from 'react-hot-toast';
import { IoMdCloseCircle } from 'react-icons/io';
import { Props as ModalProps } from 'react-modal';
import Modal from 'react-modal';

import Button from 'components/Button';
import { Review, ReviewDTO } from 'interfaces/Review';
import { db } from 'services/firebase';

import {
  Container,
  ReviewHeader,
  ReviewAuthor,
  ReviewVeredict,
  ReviewMessage,
} from './styles';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: '50%',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '10px',
  },
};

interface AddReviewModalProps extends ModalProps {
  serviceId?: string;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setReviews: React.Dispatch<React.SetStateAction<Review[]>>;
}

const AddReviewModal: React.FC<AddReviewModalProps> = ({
  serviceId,
  isOpen,
  setIsModalOpen,
  setReviews,
}) => {
  const [authorName, setAuthorName] = useState('');
  const [positive, setPositive] = useState(true);
  const [message, setMessage] = useState('');

  const addReview = useCallback(async () => {
    if (!serviceId) {
      toast.error('Ocorreu um erro inesperado. Tente novamente');
      return;
    }

    const newReview: ReviewDTO = {
      author: {
        name: authorName,
        id: '',
      },
      // TODO: Define circle specific to user
      circle: {
        id: 'JO',
        name: 'Jardim Oceânico',
      },
      message,
      positive,
      serviceId,
    };

    const docRef = await addDoc(
      collection(db, `services/${serviceId}/reviews`),
      newReview,
    );

    setReviews((reviews) => [...reviews, { id: docRef.id, ...newReview }]);

    setIsModalOpen(false);
    toast.success('Indicação adicionada com sucesso');
  }, [serviceId, authorName, message, positive, setReviews, setIsModalOpen]);

  return (
    <Modal isOpen={isOpen} style={customStyles} ariaHideApp={false}>
      <Container>
        <ReviewHeader>
          <div>
            <div>
              <label htmlFor="authorName">Autor: </label>
              <ReviewAuthor
                id="authorName"
                type="text"
                value={authorName}
                onChange={(e) => setAuthorName(e.target.value)}
              />
            </div>
            <div>
              <label htmlFor="positive">Avaliação positiva: </label>{' '}
              <ReviewVeredict
                id="positive"
                type="checkbox"
                checked={positive}
                onChange={() => setPositive(!positive)}
              />
            </div>
          </div>
          <IoMdCloseCircle size={30} onClick={() => setIsModalOpen(false)} />
        </ReviewHeader>
        <br />
        <label htmlFor="message">Mensagem:</label>
        <ReviewMessage
          id="message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
        <Button type="button" onClick={addReview}>
          Salvar
        </Button>
      </Container>
    </Modal>
  );
};

export default AddReviewModal;
